import { Container, Row, Col, Card, CloseButton, Modal, Badge } from "react-bootstrap";
import { useParamIds } from "./Data/Common";
import { getStateEnumFromCode, showStateName } from "./Data/UsState";
import { Link, useLoaderData, useNavigate } from "react-router-dom";
import { ParkerInfo, StatusOption, Subscription, SubscriptionParker, SubscriptionParkerChangeReq, Vehicle } from "./Data/ApiTypes";
import { useMemo, useState } from "react";
import { Api } from "./Data/Api";
import { processResult } from "./Data/Result";
import { Hyperlink } from "./Controls/Hyperlink";
import { AddVehicleModal } from "./Controls/AddVehicleModal";
import { currentSpaces as getCurrentSpaces, getInstructions, showSubscriptionStatus } from "./Data/Subscription";
import { InviteParkerModal } from "./UserPlanDetailsPageInviteParkerModal";
import { ConfirmModal } from "./Controls/ConfirmModal";
import { ChooseVehicleModal } from "./Controls/ChooseVehicleModal";
import { Compass, CreditCard, FileText, PeopleFill } from "react-bootstrap-icons";
import { Button } from "./Controls/Button";
import { showAddressHtml, showFacilityAddress } from "./Data/Location";
import { HeaderText } from "./Controls/HeaderText";
import { PageTitle } from "./Controls/PageTitle";
import { CardSection } from "./Controls/CardSection";
import { InfoBox } from "./Controls/InfoBox";
import { showDate } from "./Data/Date";
import React, { useEffect } from "react";
import { SubscriptionStatus } from "./Data/ApiTransport";
import { useForm } from "react-hook-form";
import { emitSubscriptionParkerChangeReq } from "./Data/ApiEmit";
import { LocalDate } from "@js-joda/core";
import ReactivatePlanModal from "./UserPlanReactivationModal";
import UserPlanCancellationModal from "./UserPlanCancellationModal";
import ParkerEditModal from "./ParkerEditModal";
import { toast } from "react-toastify";
import { WaitlistNoticeModal } from "./WaitlistNoticeModal";
import { createApiService } from "./shared/apiConfig";
import { SubscriptionApi, ServerRequestsParkerOptInFee, DataEntitiesFinanceOperatorFeeCalc, SubscriptionGroupsApi, ServerRequestsSubscriptionGroupsResponse, ServerRequestsSubscriptionGroupContractRuleDto } from "./shared/api/axios-client";
import { showMoney, cents } from "./Data/Money";
import { NoMoreSpacesModal } from "./NoMoreSpacesDialog";
import { GroupModal } from "./GroupModal";
import { useSubscriptionParkersActions } from "./UseSubscriptionParkersActions";
import ContractDetailsModal from "./ContractDetailsModal";
import { CostProjectionDto, CostProjectionSection } from "./CostProjectionSection";
import { mapCostProjection } from "./CostProjectionMapper";

enum Partner {
    ParkGuard = 0
}

export interface ReservationVehicleCardProps {
    vehicle: Vehicle;
    onRemove: ( v: Vehicle ) => void;
    subscriptionStatus: SubscriptionStatus;
}

export function ReservationVehicleCard( { vehicle, onRemove, subscriptionStatus }: ReservationVehicleCardProps ) {
    return <div className="mb-2 m-2">
        <div className="gap-1"
            style={{
                display:             "grid",
                alignItems:          "center",    /*  color make model */
                gridTemplateColumns: "min-content 1fr auto"
            }}>
            <div className="rounded-2 border border-secondary me-2"
                style={{ height: "32px", width: "32px", backgroundColor: vehicle.color }} />
            <div style={{ display: "grid", alignItems: "center", gridTemplateRows: "auto auto" }}>
                <div className="fw-bold d-flex flex-column gap-1">
                    {vehicle.make} {vehicle.model}
                </div>
                <div className="grid-col-1">
                    {showStateName( getStateEnumFromCode( vehicle.stateCode )! )} {vehicle.licensePlateNumber}
                </div>
            </div>
            {(subscriptionStatus == SubscriptionStatus.Active || subscriptionStatus == SubscriptionStatus.Applied) && (
            <div className="ms-3">
                <CloseButton onClick={() => onRemove( vehicle )} />
            </div>
            )}
        </div>
    </div>;
}

interface PaymentMethodModalProps {
    show:                boolean;
    setShow:             (show: boolean) => void;
    handleRemovePayment: () => void;
    paymentMethod:       string;
}

export function PaymentMethodModal({ show, setShow, paymentMethod, handleRemovePayment }: PaymentMethodModalProps) {
    const { planId }                        = useParamIds();
    const nav = useNavigate();
    return (
        <Modal centered show={show} onEscapeKeyDown={() => setShow(false)}>
            <Modal.Header>
                <HeaderText>Payment Method</HeaderText>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3 px-2">
                    <p>
                        This plan is set up to renew using <strong>{paymentMethod}</strong>
                    </p>
                </div>
                <div className="d-flex flex-row justify-content-end gap-2">
                    <Button className="w-50 m-2" onClick={ () => setShow(false) }>
                        Close
                    </Button>
                    <Button className="w-50 btn-main m-2" onClick={() => nav(`/user/plan/${planId}/setup`)}>
                        Change                        
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}
export function UserPlanDetailsPage() {
    const nav = useNavigate();
    const { planId }                        = useParamIds();
    const [showInvite, setShowInviteParker] = useState( false );
    const [showAdd, setShowAdd]             = useState( false );
    const [showChoose, setShowChoose]       = useState( false );
    const [loadedSub,   loadedVehicles, loadedGroups] = useLoaderData() as [Subscription, Vehicle[],
     ServerRequestsSubscriptionGroupsResponse[]];
    const [sub,         setSub]             = useState( loadedSub );
    const [parkers,     setParkers]         = useState( sub.parkers    );
    const [subVehicles, setSubVehicles]     = useState( sub.vehicles   );
    const [myVehicles,  setMyVehicles]      = useState( loadedVehicles );
    const [showMethod,  setShowMethod]      = useState( false );
    const [showReactivationModal, setShowReactivationModal] = useState(false);
    const [showCancellationModal, setShowCancellationModal] = useState(false);
    const [showLinkVehicleModal, setShowLinkVehicleModal] = useState(false);
    const [selectedParker, setSelectedParker] = useState<SubscriptionParker>();
    const [chooseModalVehicles, setChooseModalVehicles] = useState<Vehicle[]>([]);
    const [chooseModalExclude, setChooseModalExclude] = useState<number[]>([]);
    const [showWaitlistModal, setShowWaitlistModal] = useState(false);
    const [servicesLoading, setServicesLoading] = useState(true);
    const [availableServices, setAvailableServices] = useState<ServerRequestsParkerOptInFee[]>([]);
    const [serviceSelection, setServiceSelection] = useState<{ [operatorFeeId: number]: boolean }>({});
    const [showServiceConfirm, setShowServiceConfirm] = useState(false);
    const [pendingService, setPendingService] = useState<ServerRequestsParkerOptInFee | undefined>(undefined);
    const [pendingServiceNewValue, setPendingServiceNewValue] = useState<boolean>(false);
    const [showNoSpacesModal, setShowNoSpacesModal] = useState(false);
    const [showGroupModal, setShowGroupModal] = useState(false);
    const [editingGroup, setEditingGroup] = useState<ServerRequestsSubscriptionGroupsResponse | undefined>();
    const [showRemoveGroup, setShowRemoveGroup] = useState(false);
    const [groupToRemove, setGroupToRemove] =
    useState<ServerRequestsSubscriptionGroupsResponse | undefined>();
    const [groups, setGroups] =  useState<ServerRequestsSubscriptionGroupsResponse[]>(loadedGroups);
    const [selectedContract, setSelectedContract] = useState<ServerRequestsSubscriptionGroupContractRuleDto[]>([]);
    const [selectedGroupName, setSelectedGroupName] = useState<string | undefined>(undefined);
    const [showContractModal, setShowContractModal] = useState(false);

    const [currentProjection, setCurrentProjection] = useState<CostProjectionDto | null>(null);
    const [nextProjection, setNextProjection] = useState<CostProjectionDto | null>(null);
    const [costProjectionLoading, setCostProjectionLoading] = useState(false);
    const [hasFetchedCostProjection, setHasFetchedCostProjection] = useState(false);

    const {
    parkerRemove,
    vehicleAdd,
    vehicleRemove,
    vehicleLink,
    parkerInvite,
    openChooseModalForParkersList
    } = useSubscriptionParkersActions({
    subscriptionId: sub.subscriptionId,
    setParkers,
    selectedParker,
    setSelectedParker,
    onNoSpaces: () => setShowNoSpacesModal(true),
      setShowChooseVehicle: setShowChoose,
      setChooseModalExclude: setChooseModalExclude,
      setChooseModalVehicles: setChooseModalVehicles,
      setSubVehicles,
      ownerParkerId: sub.parkerId,
    });


    const subscription = useLoaderData();

    const subGroupsApi = createApiService(SubscriptionGroupsApi);
    const isEnhancedGroup = sub.isEnhancedGroup === true;

    const { getValues } = useForm<SubscriptionParkerChangeReq>( {
        defaultValues: { ...emitSubscriptionParkerChangeReq(subscription) }
    } );

    const changeSubscriptionStatus = async (selectedStatus: SubscriptionStatus) => {
        const res = await Api.changeSubscriptionStatus(planId, selectedStatus);

        processResult(
            res,
            async (responseData) => {
                setSub(prev => ({
                    ...prev,
                    status: selectedStatus
                }));
                setShowCancellationModal(false);
                setShowReactivationModal(false);
                
                // If reactivating and the API returned fee data, update the services
                if (selectedStatus === SubscriptionStatus.Active && responseData) {
                    try {
                        // Check if responseData contains fee information
                        const data = typeof responseData === 'string' ? JSON.parse(responseData) : responseData;
                        if (data && (data.parkerOptInFees || data.availableOptInFees)) {
                            const fees = data.parkerOptInFees ?? data.availableOptInFees ?? [];
                            setAvailableServices(fees);
                            const defaults: { [id: number]: boolean } = {};
                            fees.forEach(fee => {
                                const id = fee.operatorFeeId || 0;
                                const isOptedIn = (fee as any)?.isOptedIn as boolean | undefined;
                                defaults[id] = isOptedIn ?? (fee.isDefaultOptIn || false);
                            });
                            setServiceSelection(defaults);
                        }
                    } catch (parseError) {
                        // If parsing fails, reload services from API
                        await reloadServices();
                    }
                }
            },
            err => {
                toast.error(err);
            }
        );
    };

    const openChooseModalForSubList = () => {
        setChooseModalVehicles(myVehicles);
        setChooseModalExclude(subVehicles.map(sv => sv.vehicleId));
        setShowChoose(true);
    };



    //remove parker
    const [showRemove,   setShowRemove]     = useState( false );
    const [removeParker, setRemoveParker]   = useState<ParkerInfo>();

    //convenience vars
    const plan                              = sub.plan;
    const facility                          = sub.facility;
    const quantity                          = sub.quantity;
    const planIsActive                      = sub.status === SubscriptionStatus.Active;
    const planIsCancelled                   = sub.status === SubscriptionStatus.Cancelled;

    const cancel = {
        lbl:  "Plan Is Cancelled",
        expl: "The Plan will be cancelled and will not renew",
        val: SubscriptionStatus.Active // set the plan as active, if it's cancelled
    };
    
    const reactivate = {
        lbl:  "Plan Is Active",
        expl: "Set to Active",
        val: SubscriptionStatus.Cancelled // set the plan as cancelled, if it's active
    };

    const filterStatusOptions = ( status: SubscriptionStatus ): StatusOption[] => {
        if( status === SubscriptionStatus.Cancelled ) {
            return [cancel];
        }
        if( status === SubscriptionStatus.Active ) {
            return [reactivate];
        }
        return [];
    }

    const filteredOptions: StatusOption[] = [
        ...filterStatusOptions( sub.status )
    ];

    const handlePlanReactivate = async () => {
        if (facility.isWaitlistEnabled) {
            setShowWaitlistModal(true);
        }
        else if (furthestAccessPeriodDate!.isAfter(LocalDate.now())) {
            await changeSubscriptionStatus(SubscriptionStatus.Active);
            // TODO: add audit entry
        }
        else {
             setShowReactivationModal(true);
        }
    }

    const handleActivateNow = () => {
        setShowReactivationModal(false);
        
        nav(`/user/plan/${planId}/edit`)
        // TODO: add audit entry
    }    

    const handleActivateNextCycle = async () => {
        await changeSubscriptionStatus(SubscriptionStatus.Active);
        setShowReactivationModal(false);
        // TODO: add audit entry
    }

    const openEditGroup = (group: ServerRequestsSubscriptionGroupsResponse) => {
    setEditingGroup(group);
    setShowGroupModal(true);
    };

    // Function to reload services from API
    const reloadServices = async () => {
        try {
            setServicesLoading(true);
            const api = createApiService(SubscriptionApi);
            const response = await api.getParkerOptedInFees({
                serverRequestsGetParkerOptInFeesRequest: {
                    parkerId: loadedSub.parkerId,
                    subscriptionId: loadedSub.subscriptionId,
                    facilityId: facility.facilityId,
                }
            });
            const data: any = response.data as any;
            const fees = data.parkerOptInFees ?? data.availableOptInFees ?? [];
            setAvailableServices(fees);
            const defaults: { [id: number]: boolean } = {};
            fees.forEach(fee => {
                const id = fee.operatorFeeId || 0;
                const isOptedIn = (fee as any)?.isOptedIn as boolean | undefined;
                defaults[id] = isOptedIn ?? (fee.isDefaultOptIn || false);
            });
            setServiceSelection(defaults);
        } catch (err) {
            setAvailableServices([]);
            setServiceSelection({});
        } finally {
            setServicesLoading(false);
        }
    };

    // Load Additional Services (Opt-in Fees) for this parker/subscription via axios client
    useEffect(() => {
        reloadServices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadedSub.subscriptionId, loadedSub.parkerId, facility.facilityId]);

    const handleServiceToggle = (operatorFeeId: number, checked: boolean) => {
        const svc = availableServices.find(f => (f.operatorFeeId || 0) === operatorFeeId);
        
        // Check if trying to activate an inactive ParkGuard service
        if (checked && (svc as any)?.partner === Partner.ParkGuard && !serviceSelection[operatorFeeId]) {
            toast.error("This service cannot be activated");
            return;
        }
        
        setPendingService(svc);
        setPendingServiceNewValue(checked);
        setShowServiceConfirm(true);
    };

    const confirmServiceChange = async () => {
        if (!pendingService) {
            setShowServiceConfirm(false);
            return;
        }
        const id = pendingService.operatorFeeId || 0;

       
        // Call the API to persist the change
        try {
            const api = createApiService(SubscriptionApi);
            const response = await api.changeOptInFee({
                serverRequestsChangeOptInFeeRequest: {
                    parkerId: loadedSub.parkerId,
                    subscriptionId: loadedSub.subscriptionId,
                    operatorFeeId: id,
                    isOptIn: pendingServiceNewValue,
                }
            });

            // Update service selection
            setServiceSelection(prev => ({ ...prev, [id]: pendingServiceNewValue }));
            
            // Update the fee data in availableServices with the response data
            if (response.data) {
                const responseData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
                // The API returns a single ServerRequestsParkerOptInFee object, not an array
                if (responseData && responseData.operatorFeeId) {
                    setAvailableServices(prevServices => {
                        return prevServices.map(fee => {
                            // Update the specific fee that was changed
                            if (fee.operatorFeeId === responseData.operatorFeeId) {
                                return { ...fee, ...responseData };
                            }
                            return fee;
                        });
                    });
                }
            }
            
            setShowServiceConfirm(false);
            toast.success("Updated service enrollment successfully");
        } catch (e) {
            // Revert the optimistic update on error
            setServiceSelection(prev => ({ ...prev, [id]: !pendingServiceNewValue }));
            console.error("Failed to update opt-in fee status:", e);
            toast.error("Failed to update service enrollment");
        }
    };

    const cancelServiceChange = () => {
        setShowServiceConfirm(false);
        setPendingService(undefined);
    };

    const formatServiceAmount = (fee: ServerRequestsParkerOptInFee) => {
        if ((fee as any)?.operatorFeeCalc === DataEntitiesFinanceOperatorFeeCalc.NUMBER_1) {
            return `${fee.amount}%`;
        }
        return showMoney(cents(fee.amount || 0));
    };

    async function createGroup(
    name: string
    ) {
    const res = await subGroupsApi.addGroup({
        serverRequestsSubscriptionGroupAddRequest: {
        subscriptionId: sub.subscriptionId,
        name,
        },
    });

    const group = res.data;

    if (group?.error) {
        toast.error(group.error);
        return;
    }

    setGroups(prev => [
        ...prev,
        {
        id: group.id,
        name: group.name,
        parkerCount: 0,
        },
    ]);

    toast.success('Group created successfully.');

    return group;
    }

    async function updateGroup(
    groupId: number,
    name: string
    ) {
    const res = await subGroupsApi.updateGroup({
        subscriptionGroupId: groupId,
        name,
        },
    );

    const group = res.data;

    if (group?.error) {
        toast.error(group.error);
        return;
    }

    setGroups(g =>
        g.map(gr =>
            gr.id === groupId ? { ...gr, name } : gr
        )
    );

    toast.success('Group updated successfully.');

    return group;
    }

    async function deleteGroup(groupId: number) {
    const res = await subGroupsApi.deleteGroup({
        subscriptionGroupId: groupId,
        },
    );

    if (res.data?.error) {
        toast.error(res.data?.error);
        return;
    }

    setGroups(g =>
        g.filter(gr => gr.id !== groupId)
    );

    toast.success('Group removed successfully.');
    }

    const furthestAccessPeriodDate: LocalDate | null = sub.accessPeriods.reduce((latest, ap) => ap.end.isAfter(latest.end) ? ap 
    : latest, sub.accessPeriods[0])?.end;

    const status     = showSubscriptionStatus( sub.status, sub.start );
    const instr      = getInstructions(        sub.status, furthestAccessPeriodDate, (sub.paymentMethod !== null && sub.paymentMethod.length > 0), sub.end);
    const spaces     = getCurrentSpaces( sub );

    const totalSpaces = sub.quantity;
    const totalParkers = parkers.length;

    const unallocatedSpaces = totalSpaces - totalParkers;

    const unassignedCount = useMemo(
        () => parkers.filter((p) => !p.subscriptionGroupId).length,
        [parkers]
    );

    const hasUnassigned = unassignedCount > 0;
    const hasUnallocated = unallocatedSpaces > 0;

    const showWarning = hasUnassigned || hasUnallocated;

    const refreshCostProjection = async () => {
    setCostProjectionLoading(true);
    setHasFetchedCostProjection(true);
    try {
        const subscriptionApi = createApiService(SubscriptionApi);
        const response = (await subscriptionApi.subscriptionIdCostProjectionGet({subscriptionId: sub.subscriptionId})).data!;

        if (response.currentPeriod) {
            const mappedCurrent = mapCostProjection(
            response.currentPeriod,
            parkers,
            );
            setCurrentProjection(mappedCurrent);
        }

        if (response.nextPeriod) {
            const mappedNext = mapCostProjection(
            response.nextPeriod,
            parkers, 
            );
            setNextProjection(mappedNext);
        }
    } finally {
        setCostProjectionLoading(false);
    }
    };

    // Only auto-refresh if user has explicitly fetched data in this session
    useEffect(() => {
    if (!isEnhancedGroup) return;
    if (hasFetchedCostProjection) {
        refreshCostProjection();
    }
    }, [groups, parkers]);



    return <Container fluid>
        <InviteParkerModal show={showInvite}
            setShow={setShowInviteParker}
            submit={parkerInvite} 
            isEnhancedGroup={isEnhancedGroup}/>

        <AddVehicleModal
            show={showAdd}
            setShow={setShowAdd}
            onSubmit={vehicleAdd} />

        <ChooseVehicleModal
        show={showChoose}
        setShow={setShowChoose}
        onSubmit={vehicleLink}
        vehicles={chooseModalVehicles}
        exclude={chooseModalExclude}
        onClose={() => setShowChoose(false)}
        />

        <ConfirmModal title={"Remove Parker"}
            message={"Are you sure you want to remove this parker from your plan?"}
            show={showRemove}
            setShow={setShowRemove}
            onConfirm={() => {
                if( removeParker !== undefined ) {
                    parkerRemove( removeParker.parkerId );
                }
            }} />

        <ReactivatePlanModal
            show={showReactivationModal}
            onHide={() => setShowReactivationModal(false)}
            onActivateNow={handleActivateNow}
            onActivateNextCycle={handleActivateNextCycle}
        />
        <UserPlanCancellationModal
            show={showCancellationModal}
            onHide={() => setShowCancellationModal(false)}
            onConfirmCancel={async () => await changeSubscriptionStatus(SubscriptionStatus.Cancelled)}
            hasWaitlistEntries={facility.hasWaitlistEntries}
            isWaitlistEnabled={facility.isWaitlistEnabled}
            currentSpaces={sub.quantity}
        />
        {showLinkVehicleModal && selectedParker && (
            <ParkerEditModal
                show={showLinkVehicleModal}
                onClose={() => {
                setShowLinkVehicleModal(false);
                setSelectedParker(undefined);
                }}
                parker={selectedParker}
                setParker={setSelectedParker}
                subStatus={sub.status}
                onAddNew={() => setShowAdd(true)}
                onAddExisting={() => openChooseModalForParkersList()}
                onRemoveVehicle={vehicleRemove}
                subId={loadedSub.subscriptionId}
                parkers={parkers}
                setParkers={setParkers}
                initialWaitlistRequestPayload={{
                parkerId: selectedParker.parker.parkerId,
                facilityId: facility.facilityId,
                planEntryId: sub.planEntryId,
                spacesRequested: selectedParker.quantity, 
                isAddingToExistingParker: true,
                subscriptionId: sub.subscriptionId
            }}
                isWaitlistEnabled= {facility.isWaitlistEnabled}
                hasWaitlistEntries={facility.hasWaitlistEntries}
                currentSpaces={selectedParker.quantity}
            />
        )} 

        {sub.paymentMethod && (
        <PaymentMethodModal
            setShow={setShowMethod}
            handleRemovePayment={async () => {
            const res = await Api.changeSubscriptionStatus(sub.subscriptionId, sub.status);
            processResult(
                res,
                val => {
                setSub({ ...sub, paymentMethod: null });
                setShowMethod(false);
                },
                err => toast.error(err)
            );
            }}
            paymentMethod={sub.paymentMethod}
            show={showMethod}
        />
        )}

        <Row>
            <Col>
                <Container fluid className="g-0">
                    <Row>
                        <Col xs="12">
                            <PageTitle>
                                {facility.name}
                            </PageTitle>
                            <div className="d-flex gap-2 fs-5 fw-semibold text-muted align-items-center">
                                <Badge>{status}</Badge>{plan.name}
                            </div>
                            <InfoBox>{instr}</InfoBox>
                            <div className="gap-2 align-items-center" style={{ display: "grid", gridTemplateColumns: "max-content 1fr" }}>
                            {(planIsActive || planIsCancelled) && filteredOptions.map((f, index) => {
                            const selectedStatus = getValues("status");
                            const isSelected = selectedStatus === f.val;

                            return (
                                <div className="form-check form-switch" key={f.val}>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id={`switch-${index}`}
                                    checked={sub.status == SubscriptionStatus.Active}
                                    onChange={() => {
                                    if (f.val == SubscriptionStatus.Active) {
                                        handlePlanReactivate();
                                    }
                                    else {
                                        setShowCancellationModal(true);
                                    }
                                    }}
                                    style={{
                                    backgroundColor: isSelected ? '#ff69b4' : '',
                                    borderColor: isSelected ? '#ff69b4' : '',
                                    }}
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={`switch-${index}`}
                                    style={{ color: isSelected ? '#ff69b4' : undefined }}
                                >
                                    {f.lbl}
                                </label>

                                <div className={isSelected ? "" : "invisible"}>
                                    {f.expl}
                                </div>
                                </div>
                            );
                            })}
                          </div>
                            {showWarning && isEnhancedGroup && (
                                <div className="alert alert-warning d-flex align-items-start gap-3 py-3 mb-3">
                                <div className="fs-5 lh-1">⚠️</div>
                        
                                <div>                                
                                    <div className="fw-semibold mb-1">Attention Required</div>
                        
                                    <div className="small mb-2">
                                    The following will be charged the base rate of{" "}
                                    <strong>{showMoney(sub.price)}</strong>:
                                    </div>
                        
                                    <ul className="mb-0 ps-3 small">
                                    {hasUnassigned && (
                                        <li>
                                        <strong>{unassignedCount}</strong> parker
                                        {unassignedCount > 1 ? "s are" : " is"} not assigned to a
                                        group
                                        </li>
                                    )}
                        
                                    {hasUnallocated && (
                                        <li>
                                        <strong>{unallocatedSpaces}</strong> unallocated space
                                        {unallocatedSpaces > 1 ? "s" : ""}
                                        </li>
                                    )}
                                    </ul>
                                    {planIsActive && groups.length > 0 && (
                                        <div className="mt-2">  
                                            <Link to={`/user/plan/${planId}/groups/parkers`} >
                                                Manage Plan
                                            </Link>
                                        </div>
                                    )}
                                </div>
                                </div>
                            )}

                            {isEnhancedGroup && (
                            <CostProjectionSection
                                current={currentProjection}
                                next={nextProjection}
                                isAccountsReceivable={sub.isAccountsReceivable}
                                onLoad={refreshCostProjection}
                                loading={costProjectionLoading}
                            />
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <div className="gap-2 w-100" style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gridAutoRows: "1fr" }}>

                                <CardSection
                                    icon={<Compass />}
                                    onClick={ () => window.open( `http://maps.apple.com/?q=${encodeURIComponent( showFacilityAddress( facility.address ) )}` )}
                                    title="Location"
                                    content={showAddressHtml( facility.address )}
                                    change="Directions" />

                               
                                {planIsActive && !isEnhancedGroup && !sub.plan.isOneTermParking && (
                                    <CardSection
                                        onClick={ () => sub.isEnhancedGroup ? nav( `/user/plan/${planId}/groups/parkers` ) :  nav( `/user/plan/${planId}/edit` )}
                                        title={`Parking`}
                                        content={<div>
                                            <div>You have purchased <strong>{spaces}</strong> spots.</div>
                                            <div>Your plan will renew with <strong>{sub.quantity}</strong> spots</div>
                                        </div>}
                                        icon={quantity}
                                        change="Spots upon Renewal" />
                                )}
                                {planIsActive && !sub.end && (
                                    <CardSection
                                        icon={<CreditCard />}
                                        onClick={() => {
                                            if( !sub.paymentMethod ) {
                                                nav( `/user/plan/${planId}/setup` );
                                                return;
                                            }
                                            setShowMethod( true );
                                        }}
                                        title={"Billing"}
                                        change={sub.paymentMethod 
                                            ? `${sub.paymentMethod}`
                                            : "Add Payment Method"
                                        }
                                        content={sub.paymentMethod 
                                            ? "You will be billed for renewal on " + showDate(furthestAccessPeriodDate)
                                            : "Your plan is active and you will be invoiced" } />
                                    )}
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-2 g-2 mb-4">
                        <Col xs="12" lg="12">
                        {sub.plan.isOneTermParking &&
                            <Card>
                                <Card.Header style={{ display: "grid", gridTemplateColumns: "max-content 1fr max-content max-content" }}>
                                    <div>
                                        Parking
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div>
                                        <div>You have purchased <strong>{spaces}</strong> spots.</div>
                                    </div>
                                </Card.Body>
                            </Card>
                        }
                              {/* Additional Services card */}
                            {(servicesLoading || availableServices.length > 0) && (
                            <Card className="mt-3">
                                <Card.Header style={{ display: "grid", gridTemplateColumns: "max-content 1fr max-content" }}>
                                    <div>
                                        Additional Services
                                    </div>
                                    <div></div>
                                    <div></div>
                                </Card.Header>
                                <Card.Body>
                                    {servicesLoading && (
                                        <div className="text-secondary">Loading...</div>
                                    )}
                                    {!servicesLoading && availableServices.length > 0 && (
                                        <div className="d-flex flex-column gap-3">
                                            {availableServices.map((fee, index) => (
                                                <div key={fee.operatorFeeId || index}>
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <div className="d-flex flex-column">
                                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                                <Badge className={serviceSelection[(fee.operatorFeeId || 0)] ? "" : "bg-secondary"}>
                                                                    {(fee as any)?.status || (serviceSelection[(fee.operatorFeeId || 0)] ? "Active" : "Not Active")}
                                                                </Badge>
                                                                <div className="fw-bold">{fee.name || "Service"}</div>
                                                            </div>
                                                            <div className="text-muted small">
                                                                <b>Price:</b> {formatServiceAmount(fee)}
                                                                {(fee as any).isPerSpace && <span className="ms-1">/ space</span>}
                                                            </div>
                                                            {(fee as any)?.receiptNum && (
                                                                <div className="text-muted small mt-1">
                                                                    <b>Confirmation #: </b>{(fee as any).receiptNum}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="form-check form-switch">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                role="switch"
                                                                id={`service-${fee.operatorFeeId || index}`}
                                                                checked={!!serviceSelection[(fee.operatorFeeId || 0)]}
                                                                disabled={!planIsActive}
                                                                onChange={(e) => handleServiceToggle(fee.operatorFeeId || 0, e.target.checked)}
                                                            />
                                                        </div>
                                                    </div>
                                                    {(fee as any)?.receiptDescription && (
                                                        <>
                                                            <hr className="my-2" />
                                                            <div style={{ marginBottom: "-15px" }}
                                                                className="text-muted small mt-1 "
                                                                dangerouslySetInnerHTML={{ __html: (fee as any).receiptDescription }}
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                            )}

                            <Card className="mt-3">
                                <Card.Header
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "max-content 1fr max-content",
                                    alignItems: "center",
                                }}
                                >
                                <div>
                                    {isEnhancedGroup ? "Groups" : "Parkers"}
                                </div>

                                <div />

                                <div>
                                    {isEnhancedGroup && (
                                    <>
                                        {planIsActive && groups.length > 0 && (
                                        <Link to={`/user/plan/${planId}/groups/parkers`}>
                                            Manage Plan
                                        </Link>
                                        )}

                                        {planIsActive && (
                                        <>
                                            {groups.length > 0 && <>&nbsp;|&nbsp;</>}

                                            <Link
                                            to=""
                                            onClick={(e) => {
                                                setEditingGroup(undefined);
                                                e.preventDefault();
                                                setShowGroupModal(true);
                                            }}
                                            >
                                            Add Group
                                            </Link>
                                        </>
                                        )}
                                    </>
                                    )}

                                    {(planIsActive && !isEnhancedGroup) && (
                                    <Link
                                    to=""
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowInviteParker(true);
                                    }}
                                    >
                                    Add Parker
                                    </Link>
                                    )}
                                </div>
                                </Card.Header>

                                <Card.Body className="p-0 m-0 border-0">
                                    {isEnhancedGroup ? (
                                        <>
                                        {groups.length === 0 && (
                                        <div className="d-flex flex-column align-items-center justify-content-center text-center py-5">
                                            <div
                                            className="rounded-circle mb-3"
                                            style={{
                                                width: 72,
                                                height: 72,
                                                backgroundColor: "rgba(220, 53, 69, 0.15)",
                                            }}
                                            />

                                            <p className="text-secondary mb-4">
                                                Create your first group to organize tiers of parkers
                                            </p>

                                            <Button
                                            className="btn-main px-4"
                                            onClick={() => {
                                                setEditingGroup(undefined);
                                                setShowGroupModal(true);
                                            }}
                                            >
                                            Create Group
                                            </Button>
                                        </div>
                                        )}

                                        {groups.map((g) => (
                                            <div
                                            key={g.id}
                                            className="rounded-0 border-1 border-0-top w-100"
                                            >
                                            <div className="p-2 px-3 d-flex align-items-center gap-2 bg-primary-subtle bg-gradient">

                                            <div
                                                className="me-auto text-truncate fw-semibold"
                                                style={{ maxWidth: "75%" }}
                                            >
                                                <Hyperlink
                                                onClick={() => openEditGroup(g)}
                                                >
                                                {g.name}
                                                </Hyperlink>

                                                <span className="badge bg-secondary ms-2">
                                                {g.parkerCount} parkers
                                                </span>

                                                {g.contractRules && g.contractRules.length > 0 && (
                                                <span
                                                    className="badge bg-success ms-2 cursor-pointer"
                                                    onClick={() => {
                                                        setSelectedContract(g.contractRules!);
                                                        setShowContractModal(true);
                                                        setSelectedGroupName(g.name!);
                                                    }}
                                                    title="View contract"
                                                >
                                                    Contract
                                                </span>
                                                )}
                                            </div>

                                        {g.contractRules && g.contractRules.length > 0 && ( 
                                          <Button
                                            variant="link"
                                            className="p-0 border-0 shadow-none"
                                            title={"View Contract"}
                                            onClick={() => {
                                                setSelectedContract(g.contractRules!);
                                                setShowContractModal(true);
                                                setSelectedGroupName(g.name!);
                                            }}
                                            >
                                                <FileText className="icon-shift-up" />
                                            </Button>
                                        )}

                                            <Button
                                            variant="link"
                                            className="p-0 border-0 shadow-none"
                                            title="Manage parkers"
                                            onClick={() =>
                                            nav(
                                            `/user/plan/${planId}/groups/parkers?groupId=${encodeURIComponent(
                                                g.id!
                                            )}`
                                            )
                                            }
                                            >
                                                <PeopleFill className="icon-shift-up" />
                                            </Button>

                                            {planIsActive && ((g.contractRules && g.contractRules.length == 0) || !g.contractRules) &&  (
                                                <CloseButton
                                                onClick={() => {
                                                    setGroupToRemove(g);
                                                    setShowRemoveGroup(true);
                                                }}
                                                />
                                            )}
                                            </div>
                                            </div>
                                        ))}
                                        </>) :
                                        <>
                                        {parkers.length === 0 && (
                                            <div className="grid-col-1 text-secondary p-3">
                                            Invite others to this plan to let them manage their own vehicles.
                                            </div>
                                        )}

                                        {parkers.map((p) => {
                                            const parker = p.parker;

                                            return (
                                            <div
                                                key={parker.parkerId}
                                                className="rounded-0 border-1 border-0-top w-100"
                                                role="alert"
                                            >
                                                <div className="p-2 px-3 d-flex align-items-center gap-2 bg-primary-subtle bg-gradient rounded-0">
                                                <div className="me-auto">
                                                    {sub.status === SubscriptionStatus.Active ? (
                                                    <Hyperlink
                                                        onClick={() => {
                                                        setSelectedParker(p);
                                                        setShowLinkVehicleModal(true);
                                                        }}
                                                    >
                                                        {parker.name}
                                                    </Hyperlink>
                                                    ) : (
                                                    <span>{parker.name}</span>
                                                    )}

                                                    &nbsp;
                                                    <small className="text-secondary">
                                                    {parker.isManaged && <span>{parker.emailAddress}</span>}
                                                    </small>
                                                </div>

                                                {planIsActive && (
                                                    <CloseButton
                                                    onClick={() => {
                                                        setRemoveParker(parker);
                                                        setShowRemove(true);
                                                    }}
                                                    className="cursor-pointer"
                                                    />
                                                )}
                                                </div>
                                            </div>
                                            );
                                        })}
                                        </>
                                    }
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            {/* Confirmation modal for service changes */}
            <Modal centered show={showServiceConfirm} onEscapeKeyDown={() => setShowServiceConfirm(false)}>
                <Modal.Header>
                    <HeaderText>Confirm Service Change</HeaderText>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-2">
                        {pendingServiceNewValue ? (
                            <>
                                <div className="mb-2">Are you sure you want to activate <strong>{pendingService?.name}</strong>?</div>
                                {/* Currently not possible to reactivate for ParkGuard */}
                                {(pendingService as any)?.status === "Confirmed" ? (
                                    <div>The service will be activated for <strong>{pendingService ? formatServiceAmount(pendingService) : ''}</strong> with the next renewal cycle on {furthestAccessPeriodDate ? <strong>{showDate(furthestAccessPeriodDate)}</strong> : 'the end of the current period'} and will be renewed thereafter.</div>
                                ) : (
                                    <div>The service will be activated with the next renewal cycle on {furthestAccessPeriodDate ? <strong>{showDate(furthestAccessPeriodDate)}</strong> : 'the end of the current period'} and will be renewed thereafter.</div>
                                )}
                            </>
                        ) : (
                            <>
                                <div className="mb-2">Are you sure you want to cancel <strong>{pendingService?.name}</strong>?</div>
                                {(pendingService as any)?.status === "Confirmed" && (
                                    <div>
                                        The service will be discontinued on {furthestAccessPeriodDate ? <strong>{showDate(furthestAccessPeriodDate)}</strong> : 'the end of the current period'} and you will not be charged on the next renewal cycle.
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="m-2" onClick={cancelServiceChange}>Cancel</Button>
                    <Button className="btn-main m-2" onClick={confirmServiceChange}>{pendingServiceNewValue ? "Confirm" : "Confirm Cancellation"}</Button>
                </Modal.Footer>
            </Modal>
              
              {!isEnhancedGroup && (
                <Card className="mt-3">
                    <Card.Header style={{ display: "grid", gridTemplateColumns: "max-content 1fr max-content max-content" }}>
                        <div>
                            My Vehicles
                        </div>
                        <div>

                        </div>
                        <div>
                            {(planIsActive) && (
                                <>
                                    <Link to="" onClick={() => setShowAdd(true)}>Add New</Link>
                                    {myVehicles.length !== 0 && <>&nbsp;|&nbsp;<Link to="" onClick={() => openChooseModalForSubList()}>Add Existing</Link></>}
                                </>
                            )}
                        </div>
                    </Card.Header>
                    <Card.Body>
                        {subVehicles.length === 0 && <div className="text-secondary">
                            You can add or remove vehicles to this plan at any time.  Each vehicle listed here uses a spot
                        </div>}
                        {subVehicles.map( v => <ReservationVehicleCard key={v.vehicleId} vehicle={v} onRemove={vehicleRemove} subscriptionStatus={sub.status}/> )}
                    </Card.Body>
                </Card>
              )}
                <Card className="mt-3">
                    <Card.Header>
                        <div>
                            Access Periods
                        </div>
                    </Card.Header>
                    <Card.Body style={{ display: "grid", gridTemplateColumns: "auto auto auto auto" }}>
                        <div className="border-bottom border-primary border-1 text-center">Id</div>
                        <div className="border-bottom border-primary border-1 text-center">Spots</div>
                        <div className="border-bottom border-primary border-1 text-center">Start</div>
                        <div className="border-bottom border-primary border-1 text-center">End</div>
                        {sub.accessPeriods.map(ap => (
                            <React.Fragment key={ap.accessPeriodId}>
                                <div className="text-center">#{ap.accessPeriodId}</div>
                                <div className="text-center">{ap.quantity} Spots</div>
                                <div className="text-center">{showDate(ap.start)}</div>
                                <div className="text-center">{showDate(ap.end)}</div>
                            </React.Fragment>
                        ))}
                    </Card.Body>
                </Card>
                 <Button type="button" className="w-50 my-4" onClick={() => nav( -1 )}>
                    Back
                </Button>
            </Col>
        </Row>
            <WaitlistNoticeModal
                show={showWaitlistModal}
                requestPayload={{
                    parkerId: loadedSub.parkerId,
                    facilityId: facility.facilityId,
                    planEntryId: loadedSub.planEntryId,
                    spacesRequested: loadedSub.quantity,
                    isAddingToExistingParker: true,
                    subscriptionId: loadedSub.subscriptionId
                }}
                onCancel={() => setShowWaitlistModal(false)}
                onWaitlistSuccess={async () => await changeSubscriptionStatus(SubscriptionStatus.Waitlisted)}
            />

            <NoMoreSpacesModal
                show={showNoSpacesModal}
                setShow={setShowNoSpacesModal}
                planId={planId}
            />

            <GroupModal
            show={showGroupModal}
            onClose={() => setShowGroupModal(false)}
            group={editingGroup}
            existingGroups={groups}
            onSubmit={async (name, groupId) => {
                if (groupId) {
                await updateGroup(groupId, name);
                } else {
                await createGroup(name);
                }
            }}
            />

            <ContractDetailsModal
            show={showContractModal}
            contract={selectedContract}
            onHide={() => {
                setShowContractModal(false);
                setSelectedContract([]);
                setSelectedGroupName(undefined);
            }}
            groupName={selectedGroupName!}
            />

            <ConfirmModal
            title="Remove Group"
            message={
            groupToRemove ? (
                <>
                Are you sure you want to remove this group?{" "}
                {groupToRemove.parkerCount! > 0 && (
                <strong>
                    All {groupToRemove.parkerCount} parkers will be removed from the group.
                </strong>
                    )}
                </>
            
            ) : null
            }
            show={showRemoveGroup}
            setShow={setShowRemoveGroup}
            onConfirm={() => {
                if (groupToRemove?.id) {
                deleteGroup(groupToRemove.id);
                }
            }}
            />
    </Container>;
}